import { render, staticRenderFns } from "./x-tinymce.vue?vue&type=template&id=3411dc48"
import script from "./x-tinymce.vue?vue&type=script&lang=js"
export * from "./x-tinymce.vue?vue&type=script&lang=js"
import style0 from "./x-tinymce.vue?vue&type=style&index=0&id=3411dc48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports